export default __webpack_public_path__ + "static/Third-04cc34197652f3d29226202f4e7cf7c6.svg";